module.exports = __webpack_public_path__ + "img/tooltip.1af7b926.svg";